import React from "react"
import FieldPopover_InlineEditable from "../../../popover/render/inline-editable";
import {isEqualMomentRange} from "../../../../../gd/utils/datetime/is-equal-moment-range";

// const debug = "FieldDateRange_InlineEditable"
const debug = false


export default class FieldDateRange_InlineEditable extends FieldPopover_InlineEditable {


    // We need to redefine it as we compare dateranges and simple != doesn't work at all
    // we need a better function for the future I guess
    static getDerivedStateFromProps(props:any, state:any) {

        const newValue = props.field.getViewValue(props.model)

        debug && console.log(debug, "getDerivedStateFromProps newValue=", newValue)

        // if (newValue !== state.initialPropsValue) {
        if (!isEqualMomentRange(state.initialPropsValue, newValue)) {

            debug && console.log(debug, "props have changed - apply to state and set initialPropsValue")

            return {
                initialPropsValue   : newValue,
                currentValue        : newValue
            }
        }
        return null
    }

}
